module.exports = __webpack_public_path__ + "img/telegram_mt_social.6c6f8beb.svg";